export default class RawMaterialArticlesController {
  constructor(ContentService, $state) { 
    this.service = ContentService;
    this.state = $state;
  }

  $onInit(){
    this.subscriptions = [];

    if (!this.material){
      this.state.go('rawMaterials');
      return;
    };

    this.subscriptions.push(
      this.service.getArticlesList().subscribe((articles) => {
        this.articles = articles;
        const included = Object.keys(this.material.articles).map(k => parseInt(k));      
        this.associatedArticles = this.articles.filter(article => {
          return included.includes(article.id);
        }).reduce((acc, article) => {
          article.associated = true; 
          article.amount = this.material.articles[article.id]
          acc.push(article);
          return acc;
        }, []).sort((a,b) => a.description < b.description? -1 : a.description > b.description ? 1 : 0);
      })
    );
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  searchArticles(filter, articles){
    return articles.filter(article => article.description.toLowerCase().includes(filter.toLowerCase()));
  }

  selectArticle(article){
    if (article){
      this.$parent.$ctrl.associatedArticles.push(article.originalObject);
    }
  }

  associateArticle(article){
    let parent = this;
    this.subscriptions.push(
      this.service.associateArticle(this.material.id, article.id, {amount: article.amount}).subscribe(() => {
        article.associated = true;
        parent.associatedArticles.sort((a,b) => a.description < b.description? -1 : a.description > b.description ? 1 : 0)
      })
    );
  }
  disassociateArticle(article){
    let parent = this;
    this.subscriptions.push(
      this.service.disassociateArticle(this.material.id, article.id).subscribe(() => {
        parent.associatedArticles.pop(article);
        parent.associatedArticles.sort((a,b) => a.description < b.description? -1 : a.description > b.description ? 1 : 0)
      })
    );
  }

}

 RawMaterialArticlesController.$inject = ['ContentService', '$state'];



// WEBPACK FOOTER //
// ./src/app/pages/raw-material-articles/raw-material-articles.controller.js